var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.97115 0.857143V2.57143H1.99038V16.2857H11.9423V8.57143H13.9327V17.1429C13.9327 17.3702 13.8278 17.5882 13.6412 17.7489C13.4546 17.9097 13.2014 18 12.9375 18H0.995192C0.731251 18 0.47812 17.9097 0.291485 17.7489C0.104851 17.5882 0 17.3702 0 17.1429V1.71429C0 1.48696 0.104851 1.26894 0.291485 1.10819C0.47812 0.947449 0.731251 0.857143 0.995192 0.857143H5.97115ZM7.96154 5.14286C8.48942 5.14286 8.99568 5.32347 9.36895 5.64496C9.74222 5.96645 9.95192 6.40249 9.95192 6.85714H7.96154V5.14286ZM7.96154 2.57143C9.28125 2.57143 10.5469 3.02296 11.4801 3.82669C12.4132 4.63041 12.9375 5.7205 12.9375 6.85714H10.9471C10.9471 6.17516 10.6326 5.5211 10.0727 5.03887C9.51276 4.55663 8.75336 4.28571 7.96154 4.28571V2.57143ZM7.96154 0C10.0731 0 12.0981 0.722447 13.5912 2.00841C15.0843 3.29437 15.9231 5.03852 15.9231 6.85714H13.9327C13.9327 5.49317 13.3036 4.18507 12.1838 3.22059C11.064 2.25612 9.54519 1.71429 7.96154 1.71429V0Z",
    fill: "#F99B28"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpot);
export default __webpack_public_path__ + "static/media/spot.601e5befeb214483b027a747e38e4ad3.svg";
export { ForwardRef as ReactComponent };